const ANHObiWan = () => {
	return <h1>Belt - A New Hope, Obi Wan</h1>;
  };
  
  export default ANHObiWan;